export default __webpack_public_path__ + "static/1628-a95150871b17b8adf210bf925846624f.jpeg";